import { createAsyncReducer } from '../../standard-actions/';
import {
    IAddCreditcardDetailAction,
    IAddCreditcardDetailSuccessAction,
    IAddCreditcardDetailErrorAction
} from '../actions/add-creditcard-detail';
import { IBillingState } from '../state';
import { initialState } from '../state/initial-state';

export type AddCreditcardDetailAction
    = IAddCreditcardDetailAction
    | IAddCreditcardDetailSuccessAction
    | IAddCreditcardDetailErrorAction;

const init = (state: IBillingState, action: AddCreditcardDetailAction) => ({
    ...state,
    addCreditcardDetail: {
        ...state.addCreditcardDetail,
        status: action.status
    },
    showToast: {
        type: '',
        visible: false,
        text: ''
    }
});

const success = (state: IBillingState, action: AddCreditcardDetailAction) => ({
    ...state,
    addCreditcardDetail: {
        status: action.status,
        data: (action as IAddCreditcardDetailSuccessAction).data
    }
});

const failure = (state: IBillingState, action: AddCreditcardDetailAction) => ({
    ...state,
    addCreditcardDetail: {
        ...initialState.addCreditcardDetail,
        status: action.status,
        error: (action as IAddCreditcardDetailErrorAction).error,
        errorCode: (action as IAddCreditcardDetailErrorAction).errorCode
    }
});

const notStarted = (state: IBillingState, action: AddCreditcardDetailAction) => ({
    ...state,
    addCreditcardDetail: {
        status: action.status,
        data: null
    },
    showToast: {
        type: '',
        visible: false,
        text: ''
    }
});

export const addCreditcardDetailReducer = createAsyncReducer(initialState, init, success, failure, notStarted);
